export const ANNOTATION_DASHBOARD_TAG = 'annotation-dashboard';
